import { Component, Input, input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionGroupComponent } from '../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../common/accordion-item/accordion-item.component';
import { ApplicantItemPreviewComponent } from '../applicant-item-preview/applicant-item-preview.component';
import { EntityLabelPipe } from '../../../../../../../pipes/applicant-label.pipe';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../common/label/label.component';

@Component({
  selector: 'app-applicant-preview',
  standalone: true,
  imports: [
    CommonModule,
    AccordionGroupComponent,
    AccordionItemComponent,
    ApplicantItemPreviewComponent,
    EntityLabelPipe,
    LabelComponent
  ],
  templateUrl: './applicant-preview.component.html'
})
export class ApplicantPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application = input<ApplicationAppEntityApplicationRead | null>(null);

  public ngOnInit(): void {
  }
}
